import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MapPin, Route } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Container, SectionHeading, GoldButton } from "@/components/shared";

const LINC = "https://images.pexels.com/photos/8755712/pexels-photo-8755712.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const MASS = "https://images.unsplash.com/photo-1717174704421-0ce3dc8a7225?crop=entropy&cs=srgb&fm=jpg&q=85&w=940";

export default function Visit() {
  return (
    <div>
      <PageHero
        kicker="Visit"
        title="Cross for yourself"
        intro="Two working harbour towns, an ocean apart, both worth the journey. Plan a visit to either shore — or follow the sketched route that joins them."
      />

      <section className="py-16 sm:py-24">
        <Container>
          <div className="grid md:grid-cols-2 gap-6 sm:gap-8 mb-12">
            <VisitCard to="/visit/lincolnshire" img={LINC} tag="The mother town" title="Visit Lincolnshire" body="The Stump, the market place, and the Haven — two days beneath the tower." />
            <VisitCard to="/visit/massachusetts" img={MASS} tag="The daughter city" title="Visit Massachusetts" body="The harbour, the Common, and the North End — two days on the daughter shore." />
          </div>

          <div className="bg-[#1E1E2F] text-[#FFFAF3] p-8 sm:p-12 border-t-2 border-[#CDA434]">
            <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-6">
              <div className="max-w-xl">
                <div className="flex items-center gap-2 mb-3 text-[#CDA434]">
                  <Route size={18} />
                  <span className="font-sans text-xs uppercase tracking-[0.2em]">The signature itinerary</span>
                </div>
                <h2 className="font-serif text-2xl sm:text-3xl text-[#FFFAF3]">Stump to Common</h2>
                <p className="font-sans text-sm text-[#FFFAF3]/70 leading-relaxed mt-3">
                  A four-day route across both shores: two days in Lincolnshire, two in Massachusetts,
                  sketched for travellers who want to stand in both Bostons.
                </p>
              </div>
              <GoldButton as="link" to="/visit/itineraries/stump-to-common" className="whitespace-nowrap">
                Follow the route <ArrowRight size={16} className="ml-2" />
              </GoldButton>
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
}

function VisitCard({ to, img, tag, title, body }) {
  return (
    <Link to={to} className="group bg-[#FFFAF3] border border-[#D6D3CB] hover:border-[#CDA434] transition-colors overflow-hidden">
      <div className="relative h-56 overflow-hidden">
        <img src={img} alt={title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
        <span className="absolute top-4 left-4 bg-[#FFFAF3] text-[#1E1E2F] text-xs font-sans uppercase tracking-widest px-3 py-1.5">{tag}</span>
      </div>
      <div className="p-8">
        <h3 className="font-serif text-xl text-[#1E1E2F] group-hover:text-[#003366] transition-colors flex items-center gap-2">
          <MapPin size={16} className="text-[#CDA434]" /> {title}
        </h3>
        <p className="font-sans text-sm text-[#505A68] leading-relaxed mt-3">{body}</p>
      </div>
    </Link>
  );
}
